import { MonitorIcon } from "assets";
import { useTranslation } from "i18n";

const WebsiteButtonContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <span className="transition-transform group-hover:scale-110">
        <MonitorIcon />
      </span>
      {t("common:profile.button.website")}
    </>
  );
};

export default WebsiteButtonContent;
